import React, {ChangeEvent, PureComponent, ReactNode, FocusEvent, KeyboardEvent, RefObject} from 'react';
import {KEY_ENTER} from 'app/utils/Consts';

interface AmountInputProps {
    className: string
    containerClassName: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    value: string
    autoComplete?: string
    autoFocus?: boolean
    children?: ReactNode
    disabled?: boolean
    id?: string
    inputMode?: 'decimal'
    inputRef?: RefObject<HTMLInputElement>
    name?: string
    maxLength?: number
    onBlur?: () => void
    onFocus?: (e: FocusEvent<HTMLInputElement>) => void
    onEnterClick?: () => void
    onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void
    placeholder?: string
    readOnly?: boolean
    step?: string
    type?: string
}

export default class AmountInput extends PureComponent<AmountInputProps> {
    handleKeyUp = (event: KeyboardEvent<HTMLInputElement>): void => {
        const {onEnterClick, onKeyUp} = this.props;

        if (event.key === KEY_ENTER && onEnterClick) {
            onEnterClick();
        }

        onKeyUp && onKeyUp(event);
    };

    render(): ReactNode {
        const {containerClassName, children, onChange, onFocus, value, onBlur, id, className, inputMode, type,
            autoComplete, step, maxLength, autoFocus, placeholder, readOnly, inputRef, disabled, name} = this.props;

        return <div className={containerClassName}>
            <input
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                className={className}
                disabled={disabled}
                id={id}
                inputMode={inputMode}
                name={name}
                maxLength={maxLength}
                onBlur={onBlur}
                onChange={onChange}
                onFocus={onFocus}
                onKeyUp={this.handleKeyUp}
                placeholder={placeholder}
                readOnly={readOnly}
                ref={inputRef}
                step={step}
                type={type || 'text'}
                value={value}
            />
            {children}
        </div>;
    }
}
